import { Avatar, AvatarVariant } from '@avatar/types';
import { ActorAccessLevel } from '../../../../../server/graphql/__generated.types';
import { MenuAction } from '../../../Projects/ProjectActionMenu/types';
import { VoiceGridItemActionLabel } from '.';

const calculateOptions = (inputs: {
  avatar: Avatar;
  variant?: AvatarVariant;
  activeAvatarId?: number;
  activeAvatarVariantId?: number;
  sourceIsVoicesPage?: boolean;
  onToggleFavorite: () => void;
  onToggleTeamVoice: () => void;
  onSelect: () => void;
  isFavorited?: boolean;
  isTeamVoice?: boolean;
  canUpdateTeamVoice?: boolean;
}) => {
  const {
    avatar,
    variant,
    activeAvatarId,
    activeAvatarVariantId,
    sourceIsVoicesPage,
    onToggleFavorite,
    onToggleTeamVoice,
    onSelect,
    isFavorited,
    isTeamVoice,
    canUpdateTeamVoice,
  } = inputs;
  const avatarVariantAlreadySelected =
    avatar.id === activeAvatarId &&
    (variant?.id === activeAvatarVariantId || !variant);

  const conditionalItem = sourceIsVoicesPage
    ? { label: VoiceGridItemActionLabel.StartProject }
    : { label: VoiceGridItemActionLabel.SelectAvatar };

  let options: MenuAction[] = avatarVariantAlreadySelected
    ? []
    : [
        {
          ...conditionalItem,
          onSelect,
          show: true,
        },
      ];

  const lockedAvatar = avatar.accessLevel === ActorAccessLevel.Locked;

  // Enable option in new avatar modal, leave logic as is if old avatar modal
  const disabled = !sourceIsVoicesPage && lockedAvatar;

  if (isFavorited) {
    options = options.concat({
      label: VoiceGridItemActionLabel.RemoveFavorite,
      show: true,
      onSelect: () => onToggleFavorite(),
      disabled,
    });
  }
  if (!isFavorited) {
    options = options.concat({
      label: VoiceGridItemActionLabel.Favorite,
      show: true,
      onSelect: () => onToggleFavorite(),
      disabled,
    });
  }
  if (canUpdateTeamVoice && !isTeamVoice) {
    options = options.concat({
      label: VoiceGridItemActionLabel.AddToTeam,
      show: true,
      onSelect: () => onToggleTeamVoice(),
      disabled,
    });
  }
  if (canUpdateTeamVoice && isTeamVoice) {
    options = options.concat({
      label: VoiceGridItemActionLabel.RemoveFromTeam,
      show: true,
      onSelect: () => onToggleTeamVoice(),
      disabled,
    });
  }
  return options;
};

export default calculateOptions;
